import React from "react";
import { TextField, Grid, Typography, IconButton } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";

const SalaryInformationTab = ({ formik }) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
  } = formik;

  const deductionEntries = values.deductions ? Object.entries(values.deductions) : [];

    const handleDeductionChange = (index, field, newValue) => {
      const entries = [...deductionEntries];
      if (field === "key") {
        const [oldKey, val] = entries[index];
        entries[index] = [newValue, val];
      } else if (field === "value") {
        const [key, _] = entries[index];
        entries[index] = [key, newValue];
      }
      setFieldValue("deductions", Object.fromEntries(entries));
    };

    const handleAddDeduction = () => {
      setFieldValue("deductions", {
        ...values.deductions,
        "": "",
      });
    };

    const handleRemoveDeduction = (index) => {
      const entries = deductionEntries.filter((_, i) => i !== index);
      setFieldValue("deductions", Object.fromEntries(entries));
    };

  const allowanceEntries = values.other_allowances ? Object.entries(values.other_allowances) : [];

  const handleAllowanceChange = (index, field, newValue) => {
    const entries = [...allowanceEntries];
    if (field === "key") {
      // Change key (rename)
      const [oldKey, val] = entries[index];
      entries[index] = [newValue, val];
    } else if (field === "value") {
      // Change value
      const [key, _] = entries[index];
      entries[index] = [key, newValue];
    }

    // Convert back to object
    const updatedAllowances = Object.fromEntries(entries);
    setFieldValue("other_allowances", updatedAllowances);
  };

  const handleAddAllowance = () => {
    // Add new key-value pair with empty strings
    setFieldValue("other_allowances", {
      ...values.other_allowances,
      "": "",
    });
  };

  const handleRemoveAllowance = (index) => {
    const entries = allowanceEntries.filter((_, i) => i !== index);
    setFieldValue("other_allowances", Object.fromEntries(entries));
  };

  return (
    <Grid container spacing={2} mt={1}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Basic Salary"
          name="basic_salary"
          type="number"
          value={values.basic_salary}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.basic_salary && Boolean(errors.basic_salary)}
          helperText={touched.basic_salary && errors.basic_salary}
        />
      </Grid>

      
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="HRA"
          name="hra"
          type="number"
          value={values.hra}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.hra && Boolean(errors.hra)}
          helperText={touched.hra && errors.hra}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Bonus"
          name="bonus"
          type="number"
          value={values.bonus}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.bonus&& Boolean(errors.bonus)}
          helperText={touched.bonus && errors.bonus}
        />
      </Grid>


      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Bank Name"
          name="bank_name"
          value={values.bank_name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.bank_name && Boolean(errors.bank_name)}
          helperText={touched.bank_name && errors.bank_name}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Account Number"
          name="account_number"
          value={values.account_number}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.account_number && Boolean(errors.account_number)}
          helperText={touched.account_number && errors.account_number}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="IFSC Code"
          name="ifsc_code"
          value={values.ifsc_code}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.ifsc_code && Boolean(errors.ifsc_code)}
          helperText={touched.ifsc_code && errors.ifsc_code}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="PAN / Tax ID"
          name="pan_number"
          value={values.pan_number}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.pan_number && Boolean(errors.pan_number)}
          helperText={touched.pan_number && errors.pan_number}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="UAN / PF Number"
          name="pf_number"
          value={values.pf_number}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.pf_number && Boolean(errors.pf_number)}
          helperText={touched.pf_number && errors.pf_number}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="ESI Number"
          name="esi_number"
          value={values.esi_number}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.esi_number && Boolean(errors.esi_number)}
          helperText={touched.esi_number && errors.esi_number}
        />
      </Grid>

        <Grid item xs={12}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography variant="subtitle1">Deductions</Typography>
            </Grid>
            <Grid item>
              <IconButton color="primary" onClick={handleAddDeduction}>
                <Add />
              </IconButton>
            </Grid>
          </Grid>
            {touched.deductions && typeof errors.deductions === "string" && (
            <Typography variant="body2" color="error" sx={{ mt: 0.5, ml: 1 }}>
              {errors.deductions}
            </Typography>
          )}
        </Grid>

        {deductionEntries.map(([key, value], index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                value={key}
                onChange={(e) => handleDeductionChange(index, "key", e.target.value)}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Amount"
                type="number"
                value={value}
                onChange={(e) => handleDeductionChange(index, "value", e.target.value)}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid
              item
              xs={1}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <IconButton color="error" onClick={() => handleRemoveDeduction(index)}>
                <Delete />
              </IconButton>
            </Grid>
          </React.Fragment>
        ))}

      <Grid item xs={12}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography variant="subtitle1">Allowances</Typography>
            </Grid>
            <Grid item>
              <IconButton color="primary" onClick={handleAddAllowance}>
                <Add />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>

        {/* Entries */}
        {allowanceEntries.map(([key, value], index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                value={key}
                onChange={(e) => handleAllowanceChange(index, "key", e.target.value)}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Amount"
                type="number"
                value={value}
                onChange={(e) => handleAllowanceChange(index, "value", e.target.value)}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid
              item
              xs={1}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <IconButton color="error" onClick={() => handleRemoveAllowance(index)}>
                <Delete />
              </IconButton>
            </Grid>
          </React.Fragment>
        ))}
    
    </Grid>
  );
};

export default SalaryInformationTab;
